module.exports = __webpack_public_path__ + "pc/img/rec_00.dee326aa.svg";